const Klaviyo = require("node-klaviyo")

const KlaviyoClient = new Klaviyo({
  publicToken: process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_TOKEN,
  privateToken: process.env.KLAVIYO_PRIVATE_TOKEN,
})

export default KlaviyoClient
